import React from 'react'
import EtAddOrUpdateUserChallengeTeamEvalComp from '@/features/userChallengeTeamEvals/EtAddOrUpdateUserChallengeTeamEvalComp'
import {
    XCircleIcon
} from "@heroicons/react/24/solid"


const EtModalAddOrUpdateUserChallengeTeamEval = ({ 
    mode, 
    existingEvalData,
    isOpen, 
    onClose, 
    challengeId, 
    teamEvaluatorId, 
    teamEvaluatorOrgId, 
    userId, 
    userOrgId, 
    trailId, 
    sessionId, 

    // 20 Aug 2026 - Active cohort for this Team evaluation.
    cohortId,

    triggeringUrl,
}) => {
    // First Created - 20 Aug 2026
    // Author - Atul Pandey
    // Inherited from EtModalAddOrUpdateUserChallengeSponsorEval
    // Updated - 20 Aug 2026 - cohortId
    // Updated - 20 Aug 2026 - Team challenge evaluation support


    // console.log('triggering url', triggeringUrl)
    // console.log('cohortId in EtModalAddOrUpdateUserChallengeTeamEval', cohortId)


    if (!isOpen) return null


    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-[9999] flex justify-center items-center font-poppins">
            <div className="bg-black p-5 rounded-lg shadow-lg shadow-black relative">

                <div
                    className="absolute top-0 right-0 m-2 font-bold rounded-full cursor-pointer h-7 w-7 flex justify-center items-center"
                    onClick={onClose}
                >
                    <XCircleIcon className='text-orange-600 rounded-full hover:text-red-600 h-7 w-7'/>
                </div>


                <EtAddOrUpdateUserChallengeTeamEvalComp 
                    mode={mode} 
                    existingEvalData={existingEvalData} 
                    challengeId={challengeId} 

                    teamEvaluatorId={teamEvaluatorId} 
                    teamEvaluatorOrgId={teamEvaluatorOrgId} 

                    userId={userId} 
                    userOrgId={userOrgId} 
                    trailId={trailId} 
                    sessionId={sessionId} 

                    // 20 Aug 2026 - Pass active cohort through to the mutation payload.
                    cohortId={cohortId}

                    triggeringUrl={triggeringUrl} 
                    onClose={onClose}
                />

            </div>
        </div>
    )
}


export default EtModalAddOrUpdateUserChallengeTeamEval